import React from "react";
import { FormControl, Input, Select, Button, Flex } from "@airbus/components-react";
import { UserController } from "../controller/UserController";
import eventBus from "../eventBus/EventBus";

import '../css/Forms.css';

class UserEditForm extends React.Component {

    constructor(props){
        super(props);

        //states
        this.state={
            form:{
                id: props.id,
                username: props.username,                   //Form handler
                password: props.password,
                role: props.role,
                lastname:props.lastname,
                firstname:props.firstname,
                mail:props.mail,
            },
            windowWidth: window.innerWidth,     //screen width 
            windowHeight: window.innerHeight,   //screen height
        }

        //Notification params
        this.setNotification=this.props.notificationHandler;  //call parent notification handler


    }


    componentDidUpdate = () => {
      
        window.addEventListener("resize", this.handleResize);
    }

    /*Handle screen size*/
    handleResize = (e) => {
      
        //debugger;
        this.setState({ 
            windowWidth: window.innerWidth,
            windowHeight: window.innerHeight
        });
    
    };


    /**
     * RENDERING
     * @returns dom
     */
     render() {
        return(
        <div>
            
        
                     
        {/*USERNAME*/}
        <Flex wrap={true} direction="row" >
        <FormControl
            className="controlForm"
            error={!this.usernameValid()}
            errorText="Obligatoire"
            label="Login"
            placeholder="Login"
            required
        >
            <Input value={this.state.form.username} onChange={this.onChangeUsername} />
        </FormControl>

        {/*PASSWORD*/}
        <FormControl
            className="controlForm"
            error={!this.passwordValid()}
            errorText="Obligatoire"
            label="Mot de passe"
            placeholder="Mot de passe"
            required
        >
            <Input type="password" value={this.state.form.password} onChange={this.onChangePassword} />
        </FormControl>
        </Flex>

        {/*LAST NAME*/}
        <Flex wrap={true} direction="row" >
        <FormControl
            className="controlForm"
            error={!this.lastNameValid()}
            errorText="Obligatoire"
            label="Nom"
            placeholder="Nom"
            required
        >
            <Input value={this.state.form.lastname} onChange={this.onChangeLastName} />
        </FormControl>

        {/*FIRST NAME*/}
        <FormControl
            className="controlForm"
            error={!this.firstNameValid()}
            errorText="Obligatoire"
            label="Prénom"
            placeholder="Prénom"
            required
        >
            <Input value={this.state.form.firstname} onChange={this.onChangeFirstName} />
        </FormControl>
        </Flex>

        {/*MAIL*/}
        <Flex wrap={true} direction="row" >
        <FormControl
            className="controlForm"
            error={!this.mailValid()}
            errorText="Obligatoire"
            label="Mail"
            placeholder="Adresse email"
            required
        >
            <Input value={this.state.form.mail} onChange={this.onChangeMail} />
        </FormControl>

        {/*ROLE*/}
        <FormControl
            className="controlForm"
            error={!this.roleValid()}
            errorText="Obligatoire"
            label="Rôle"
            placeholder="Rôle"
            required
        >
           
            <Select value={this.state.form.role} placeholder="Role" onChange={this.onChangeRole} className="select-controlForm" >
                <option value='reader'>Lecture seule</option>
                <option value='writer'>Lecture / Ecriture</option>
                <option value='admin'>Administrateur</option>
            </Select>
            
        </FormControl>
        
        </Flex>
        

         {/*SUBMIT*/}
         <Flex wrap={true} direction="row" >
         <FormControl
            className="button-controlForm"
            

        >
         
            <Button variant="primary" 
                            onClick = {this.onUserSubmit}
                            disabled = {!this.usernameValid() 
                                || !this.passwordValid()
                                || !this.lastNameValid()
                                || !this.firstNameValid()
                                || !this.mailValid()
                                || !this.roleValid()
                                }
                            style={{
                                width: "100%"
                                }}>
                            MODIFIER UTILISATEUR
            </Button>
        </FormControl>
        </Flex>
        

        </div>
    )}

        

    /**
     * EVENTS
     */
    
    //Vérification Username
    usernameValid = () => {
        return this.state.form.username !== undefined && this.state.form.username.length > 0;
    };


    //USERNAME Input Change handler
    onChangeUsername = (event) => {
         
        let formData = this.state.form;
        formData.username = event.target.value;
        
        this.setState({form:formData});
         
     }

    //Vérification Mot de passe
    passwordValid = () => {
        return this.state.form.password !== undefined && this.state.form.password.length > 0;
    };

    //Password Input Change handler
    onChangePassword = (event) => {
         
        let formData = this.state.form;
        formData.password = event.target.value;
        
        this.setState({form:formData});
         
     }

    //Vérification LastName
    lastNameValid = () => {
        return this.state.form.lastname !== undefined && this.state.form.lastname.length > 0;
    };

    //LastName Input Change handler
    onChangeLastName = (event) => {
         
        let formData = this.state.form;
        formData.lastname = event.target.value;
        
        this.setState({form:formData});
         
     }

    //Vérification FirstName
    firstNameValid = () => {
        return this.state.form.firstname !== undefined && this.state.form.firstname.length > 0;
    };

    //FirstName Input Change handler
    onChangeFirstName = (event) => {
         
        let formData = this.state.form;
        formData.firstname = event.target.value;
        
        this.setState({form:formData});
         
     }

    //Vérification Mail
    mailValid = () => {
        return this.state.form.mail !== undefined && this.state.form.mail.length > 0;
    };

    //Mail Input Change handler
    onChangeMail = (event) => {
         
        let formData = this.state.form;
        formData.mail = event.target.value;
        
        this.setState({form:formData});
         
     }

    //Vérification Role
    roleValid = () => {
        return this.state.form.role !== undefined && this.state.form.role.length > 0;
    };

    //Role Option Change handler
    onChangeRole = (event) => {
         
        let formData = this.state.form;
        formData.role = event.target.value;
        
        this.setState({form:formData});
         
     }

    /*
    EVENTS
    */
     
    //Submit User Modification
    onUserSubmit = async (event) =>  {
        
        let formData = this.state.form;
     
        let response = await new UserController().updateUser(   formData.id,
                                                                formData.lastname,
                                                                formData.firstname,
                                                                formData.mail,
                                                                formData.username,
                                                                formData.password,
                                                                formData.role);
        
        if(response === undefined){
            //erreur API call
            this.setNotification(true,{
                notifVariant: "error",
                notifMessage:"API erreur: l'utilisateur n'a pu être modifié",
                notifDescription:null
              });

        }
        
        else if (response.response === "200"){           
            
            //Go back to list view
            //Export to event Bus for main component state refresh
            eventBus.dispatch("listview", { listview: true });
            
                 
            

        }
        else{
            
            //API return <> 200
            this.setNotification(true,{
                notifVariant: "error",
                notifMessage: "Erreur lors de la modification de l'utilisateur",
                notifDescription: response.response+": "+response.responseDescription
              });

        }
    }

   

}

export default UserEditForm;